import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReAuth } from './baseQueryWithReAuth';
import { ALL_TAGS } from './tags';

const api = createApi({
  reducerPath: 'rioblast',
  baseQuery: baseQueryWithReAuth,
  tagTypes: ALL_TAGS,
  endpoints: () => ({}),
});

export { api };
